export default class Publisher {
    constructor() {
        this.subscribers = new Set();
        this.getRecentlyData = () => {
            return this.data;
        };
    }
    publish(v) {
        this.subscribers.forEach((sub) => sub(v));
        this.data = v;
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return {
            unsubscribe: () => {
                this.subscribers.delete(fn);
            },
        };
    }
}
//# sourceMappingURL=index.js.map